const e = {
  name: "Tooltip",
  props: {
    event: {
      type: String,
      default: "hover"
    },
    pointer: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 160
    }
  },
  data() {
    return {
      value: ""
    };
  }
};
export {
  e as default
};
